
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { Button } from "@/components/ui/button";
import { ArrowDown, ArrowUp, GripVertical } from "lucide-react";

interface SortableItemProps {
  offering: {
    id: string;
    title: string;
    description: string;
    is_active: boolean;
    display_order: number;
  };
  index: number;
  moveItem: (index: number, direction: 'up' | 'down') => void;
  isLastItem: boolean;
}

export const SortableItem: React.FC<SortableItemProps> = ({
  offering,
  index,
  moveItem,
  isLastItem
}) => {
  return (
    <Draggable key={offering.id} draggableId={offering.id} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className="bg-[#181D24] rounded-xl p-3 border border-[#222A35] flex items-center"
        >
          <div 
            {...provided.dragHandleProps} 
            className="px-3 cursor-grab flex items-center"
          >
            <GripVertical className="text-gray-400" />
            <span className="ml-2 text-gray-400 font-mono text-sm">{index + 1}</span>
          </div>
          
          <div className="flex-grow">
            <h3 className="text-white font-medium">{offering.title}</h3>
            <p className="text-gray-400 text-sm truncate">{offering.description}</p>
          </div>
          
          <div className="flex flex-col gap-1 ml-2">
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={() => moveItem(index, 'up')}
              disabled={index === 0}
            >
              <ArrowUp className="h-4 w-4" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={() => moveItem(index, 'down')}
              disabled={isLastItem}
            >
              <ArrowDown className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </Draggable>
  );
};
